module.exports = __webpack_public_path__ + "img/BliBli.abd764a9.png";